import * as React from 'react';
import { ContextTokenProvider, createLocalAveContextTokenProvider } from 'utils/auth/localAveContextToken';

/**
 * AVS-4450: one context-token provider per committed local AVE device.
 * The same thingName keeps the same provider (and its token cache) across re-renders and
 * Showroom remounts; a new thingName yields a new provider. Returns undefined while disabled.
 */
export function useLocalAveContextTokenProvider(
  thingName: string | undefined,
  enabled: boolean
): ContextTokenProvider | undefined {
  return React.useMemo(
    () => (enabled && thingName ? createLocalAveContextTokenProvider(thingName) : undefined),
    [thingName, enabled]
  );
}
